import { render, staticRenderFns } from "./DosBoxMacOSLink.vue?vue&type=template&id=1c1198b8&"
import script from "./DosBoxMacOSLink.vue?vue&type=script&lang=js&"
export * from "./DosBoxMacOSLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports